import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import { Link } from "react-router-dom";
import { storage } from "../firebase";
import moment from 'moment';
import { db, database, expertiseRef } from '../firebase'
import closeImg from "../images/close.png";
import $ from 'jquery';
export default class NewSkill extends Component {
    constructor(props) {
        super(props)
        this.state = {

            expertise: "",
            status: "",
            id: null,
            experienceData: [],
            salExpData: []
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateSubmission = this.validateSubmission.bind(this);
        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.updateValidateSubmission = this.updateValidateSubmission.bind(this)
        this.handleNumberChange = this.handleNumberChange.bind(this);
    }
    updateValidateSubmission = () => {
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            expertise: this.state.expertise,
            status: this.state.status,
            createdAt: newDate,
            experienceSalaryDetails : this.state.salExpData
        }
        database.ref(`expertise/${this.state.id}`).update(item).then(() => {
            alert("Updated Successfully")
            window.location.href = "/expertise"
            this.renderList();

        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    handleStatusChange = (e) => {
        this.setState({
            status: e.target.value
        })
    }
    handleChange = (event) => {
        const { value, name } = event.target;
        this.setState({
          [name]: value,
        });
      };
    validateSubmission = () => {
        if (this.state.expertise === '') {
            alert('Enter Expertise')
        }
        else if (this.state.salExpData.length == 0) {
            alert('Add Experience and salary details')
        }
        else if (this.state.status === '') {
            alert('Select status')
        }
        else {
            if (this.state.id == null) {
                this.handleSubmit("");
            }
            else {
                this.updateValidateSubmission("");
            }
        }
    }

    handleSubmit = () => {
        let newDate = moment(new Date()).format("DD/MM/YYYY")
        const item = {
            expertise: this.state.expertise,
            status: this.state.status,
            createdAt: newDate,
            experienceSalaryDetails : this.state.salExpData
        }
        expertiseRef.push(item).then(() => {
            alert("Saved Successfully")
            window.location.href = "/expertise"
        }).catch(() => {
            alert("Somthing went wrong")
        })
    }
    componentDidMount() {
        const url = new URL(window.location.href);
        let url_path = window.location.href.split("=");
        let keyId = (url_path[1]);
        this.renderList(keyId)
    }
    addExpSalary() {
        var salExpData = this.state.salExpData;
        salExpData.push({
            experience: $("#experience").val(),
            salaryMin: $("#salaryMin").val(),
            salaryMax: $("#salaryMax").val(),
        });
        this.setState({ salExpData: salExpData });
        $("#experience").val("");
        $("#salaryMin").val("");
        $("#salaryMax").val("");
    }
    removeExpSalary(a, b, c) {
        var salExpData = this.state.salExpData;
        var newArray = [];
        salExpData.map((data, i) => {
          if (data.experience !== a && data.salaryMin !== b && data.salaryMax !== c) {
            newArray.push({
              experience: data.experience,
              salaryMin: data.salaryMin,
              salaryMax: data.salaryMax,
            });
          }
        });
        this.setState({ salExpData: newArray });
      }
      handleNumberChange = (event) => {
        const re = /^[0-9\b]+$/;
        if (event.target.value === "" || re.test(event.target.value)) {
        } else {
          $("#" + event.target.name).val("");
        }
      };
    async renderList(keyId) {
        let dataList = []
        let id = keyId;
        const ref = id ? '/expertise/' + id : 'expertise'
        const userRef = database.ref(ref)
        const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
        const snapshot = await valueRef.once('value')
        const val = snapshot.val()
        if (val) {
            $("#expertise").val(val.expertise)
            $("#expertiseStatus").val(val.status)
            console.log("experienceSalaryDetails...",val.hasOwnProperty('experienceSalaryDetails'))
            this.setState({
                id: id,
                expertise: val.expertise,
                status: val.status
            })
            if(val.hasOwnProperty('experienceSalaryDetails')){
                this.setState({
                    salExpData: val.experienceSalaryDetails,
                })
            }
        }
        let experienceList = [];
        await database.ref("experience").once('value', function (snapshot) {
            snapshot.forEach(function (ChildSnapshot) {
                if (ChildSnapshot.val().status == 'Active') {
                    experienceList.push({
                        experience: ChildSnapshot.val().experience
                    });
                }
            });
        });
        this.setState({
            experienceData: experienceList
        })
    }
    render() {
        return (
            <div className="main-wrapper">
                <Header></Header>
                <div className="main-content">
                    <Menu></Menu>
                    <div className="content-right-wrapper">
                        <div className="container">
                            <form className='form-wrapper'>
                                <ul className="breadcrumb">
                                    <li><a href="/dashboard">Dashboard</a></li>
                                    <li><a href="/expertise">Expertise</a></li>
                                    <li>New Expertise</li>
                                </ul>
                                <div className='form-head'>Expertise</div>
                                <div className="form-group">
                                    <label for="testimonialAuthor">Expertise</label>
                                    <input type="text" className="form-control" name="expertise" onChange={this.handleChange}
                                        id="expertise"
                                    />
                                </div>
                                <div id="whatyoudo" className="form-group">

                                    <select className="form-control" style={{ marginLeft: "1px", marginTop: "50px", width: "255px" }} onChange={this.handleChange} id="experience" name="experience">
                                        <option key="" value="">Select Experience</option>
                                        {
                                            this.state.experienceData.map((x, y) =>
                                                <option key={y}>{x.experience}</option>)
                                        }</select>

                                    <input
                                        type="text"
                                        className="form-control" style={{ marginLeft: "293px", marginTop: "-33px", width: "255px" }}
                                        name="salaryMin"
                                        id="salaryMin"
                                        onChange={this.handleChange}
                                        placeholder="Salary Min Value"
                                        onKeyUp={this.handleNumberChange}
                                    />
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="salaryMax"
                                        id="salaryMax"
                                        onChange={this.handleChange}
                                        style={{ marginLeft: "575px", marginTop: "-33px", width: "255px" }}
                                        placeholder="Salary Max Value"
                                        onKeyUp={this.handleNumberChange}
                                    />

                                    <input
                                        type="button"
                                        value="Add"
                                        onClick={() => this.addExpSalary()}
                                        style={{ marginLeft: "857px", marginTop: "-36px", float: "right" }}
                                    />

                                    {this.state.salExpData.length > 0 && (
                                        <table
                                            className="table table-bordered"
                                            style={{ marginTop: "10px" }}
                                        >
                                            <thead>
                                                <tr>
                                                    <td>Experience</td>
                                                    <td>Salary Min</td>
                                                    <td>Salary Max</td>
                                                    <td>Action</td>
                                                </tr>
                                            </thead>{" "}
                                            <tbody>
                                                {this.state.salExpData.map((data, i) => {
                                                    return (
                                                        <tr>
                                                            <td>{data.experience}</td>
                                                            <td>{data.salaryMin}</td>
                                                            <td>{data.salaryMax}</td>
                                                            <td>
                                                                <img
                                                                    src={closeImg}
                                                                    alt=""
                                                                    onClick={() =>
                                                                        this.removeExpSalary(
                                                                            data.experience,
                                                                            data.salaryMin,
                                                                            data.salaryMax
                                                                        )
                                                                    }
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    )}

                                </div>
                                <div className="form-group">
                                    <label for="skillStatus"> Status</label>
                                    <select className="form-control" onChange={this.handleStatusChange} id="expertiseStatus" name="expertiseStatus">
                                        <option value="">Select</option>
                                        <option value="Active">Active</option>
                                        <option value="Inactive">Inactive</option>
                                    </select>
                                </div>
                                <div className="form-group mt-4">
                                    <Link to="/expertise">
                                        <button type="button" className="btn btn-primary" style={{ float: "right", marginLeft: "10px" }}>Cancel</button>
                                    </Link>
                                    {this.state.id == null ?
                                        <button type="button" className="btn btn-primary" onClick={this.validateSubmission} style={{ float: "right" }}>Submit</button>
                                        :
                                        <button type="button" className="btn btn-primary" onClick={this.validateSubmission} style={{ float: "right" }}>Update</button>
                                    }
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <Footer></Footer>
            </div>
        )
    }

}


// WEBPACK FOOTER //
// ./src/admin/newExpertise.jsx